import { createSelector } from 'reselect'

export const getPopupLoginVisibility = createSelector(
  (state) => Boolean(state && state.common && state.common.isPopupLoginBlockOpened),
  (isOpened) => isOpened
)
